import { render, staticRenderFns } from "./system-banner.vue?vue&type=template&id=c74a6b7c&scoped=true&"
import script from "./system-banner.vue?vue&type=script&lang=js&"
export * from "./system-banner.vue?vue&type=script&lang=js&"
import style0 from "./system-banner.vue?vue&type=style&index=0&id=c74a6b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74a6b7c",
  null
  
)

export default component.exports